<template>
    <div v-if="mapProvider == '高德地图' ">
      <vc-layer-imagery >
        <vc-imagery-provider-amap
          :map-style="mapStyle"
          :projection-transforms="{ form: 'GCJ02', to: 'WGS84' }"
          :minimumLevel="0"
          :maximumLevel="18"
          ref="providerAmap"
        ></vc-imagery-provider-amap>
      </vc-layer-imagery>
    </div>
</template>

<script>
import { toRaw } from 'vue';
export default {
    name:'ProviderAmap',
    props:['defaultProvider'],
    
    data(){
        return {
            mapStyle:'6',
            mapProvider:'',
            mapOptions : [
                {
                    value: '6',
                    label: '卫星影像'
                },
                {
                    value: '7',
                    label: '道路图'
                },
                {
                    value: '8',
                    label: '道路图（背景透明）'
                }
            ],

        }
    },
    methods:{
        getMapStyle(mapStyle){
            this.mapStyle = mapStyle;
        },
        getMapArray(currentMap){
            if(currentMap !== "高德地图" && this.$refs.providerBaidu){
                this.$refs.providerBaidu.unload();
            }else if(currentMap == "高德地图"){
                console.log("高德Options:",this.mapOptions)
                this.mapProvider = currentMap ;
                this.$bus.emit('getMapOptions',toRaw(this.mapOptions));
                // this.mapStyle = this.mapOptions[1].value ;
            }
        }
    },
    mounted(){
        if(this.defaultProvider){
            console.log("高德Options:",this.mapOptions);
            this.mapStyle = this.mapOptions[0].value ;
            this.$bus.emit('getMapOptions',toRaw(this.mapOptions));
        }
        this.$bus.on('getMapStyle',this.getMapStyle);
        this.$bus.on('getMapArray',this.getMapArray);
        this.$bus.on("getCurrentMap",this.getMapArray);
    },
    beforeUnmount() {
        this.$bus.all.clear();
    },
}
</script>

<style>

</style>